export default "__VITE_ASSET__CoVeIF7X__"